import React, { useEffect, useState } from 'react';
import makeRequest from 'utils/makeRequest';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './CommentWidget.scss';
import { TOI_PLUS_CONFIG_DOMAIN } from 'constants';

const CommentWidget = ({ msid, onClick, isMobile }) => {
  const [commentCount, setCommentCount] = useState(0);
  const fetchData = async (url, setData) => {
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .catch(() => {
        setData(0);
      })
      .then(res => {
        if (res.data && res.data.cmt_c) {
          setData(res.data.cmt_c || 0);
        } else {
          throw new Error('No data available');
        }
      })
      .finally(() => {});
  };

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      if (isMobile) {
        window.location.href = window.location.href.replace(
          '/articleshow/',
          '/articleshow_comments/',
        );
      } else {
        onClick();
      }
      analyticsWrapper('ga4', {
        event: 'user_click',
        category: 'articleshow_sticky',
        type: 'comments',
      });
    }
  };

  useEffect(() => {
    fetchData(
      `${TOI_PLUS_CONFIG_DOMAIN}/comments/count/v2?msid=${msid}&appKey=TOI&client=toi`,
      setCommentCount,
    );
  }, []);

  return (
    <div className={s.commentWidgetWrappper} onClick={handleClick}>
      <i className={s.commentIcon} />
      {commentCount > 0 && <span> {commentCount} </span>}
      {commentCount && commentCount === 1 ? 'Comment' : 'Comments' }
    </div>
  );
};

export default CommentWidget;
